export var INJECT_KEY = "mixin_ext";